import { useRef, useCallback, useEffect } from "react";
// Adapted from react-hooks-org useOutsideClick
import { maybeToArray } from "../utils";
export function useOutsideFocus(ref, handler, when) {
    if (when === void 0) { when = true; }
    var refs = useRef(maybeToArray(ref));
    var savedHandler = useRef(handler);
    useEffect(function () {
        savedHandler.current = handler;
        refs.current = maybeToArray(ref);
    });
    var memoizedCallback = useCallback(function (e) {
        if (refs.current.every(function (ref) {
            return !ref || !ref.current || !ref.current.contains(e.target);
        })) {
            savedHandler.current(e);
        }
    }, []);
    useEffect(function () {
        // We need to use "focusin", as it bubbles while focus does not.
        if (when) {
            document.addEventListener("focusin", memoizedCallback);
            return function () {
                document.removeEventListener("focusin", memoizedCallback);
            };
        }
    }, [when]);
}
//# sourceMappingURL=useOutsideFocus.js.map